import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { server } from "../server";

// Async thunk to call the API
export const fetchSharedEvents = createAsyncThunk(
  "sharedEvents/fetchSharedEvents",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${server}/Event/GetSharedEvents`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData || "Failed to fetch shared events");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Error fetching shared events");
    }
  }
);

// Slice
const sharedEventsSlice = createSlice({
  name: "sharedEvents",
  initialState: {
    sharedEvents: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSharedEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSharedEvents.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;

        state.sharedEvents = Array.isArray(payload)
          ? payload
          : payload?.data || [];
      })
      .addCase(fetchSharedEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default sharedEventsSlice.reducer;
